module.exports = __webpack_public_path__ + "img/zaturdaylogobluewithtext.164700a0.png";